export default class RiskFormRenderer {
  // Générer le formulaire de questions
  renderQuestionsForm(questions) {
    if (questions.length === 0) {
      return `<p>Aucune question trouvée pour ce niveau de risque.</p>`
    }

    const hasExistingAnswers = questions.some(q => q.existing_answer)
    const buttonText = hasExistingAnswers ? 'Sauvegarder' : 'Créer'
    
    // Trier les questions : d'abord par niveau (général puis spécifique), puis par ordre
    const sortedQuestions = questions.sort((a, b) => {
      // Si a est général (pas de risk_level_id) et b est spécifique, a vient en premier
      if (!a.risk_level_id && b.risk_level_id) return -1
      // Si a est spécifique et b est général, b vient en premier
      if (a.risk_level_id && !b.risk_level_id) return 1
      // Si les deux sont du même type, garder l'ordre original
      return 0
    })
    
    // Séparer les questions générales des questions spécifiques
    const generalQuestions = sortedQuestions.filter(q => !q.risk_level_id)
    const specificQuestions = sortedQuestions.filter(q => q.risk_level_id)
    
    let formHtml = '<form id="risk_questions_form" style="text-align: left;">'
    
    // Afficher d'abord les questions générales
    if (generalQuestions.length > 0) {
      formHtml += '<div style="color: #96254E; margin: 1rem 0; font-weight: bold;">Questions générales</div>'
      generalQuestions.forEach((question, index) => {
        formHtml += this.renderQuestionField(question, index)
      })
    }
    
    // Puis afficher les questions spécifiques avec un séparateur
    if (specificQuestions.length > 0) {
      if (generalQuestions.length > 0) {
        formHtml += '<hr style="margin: 2rem 0; border: 1px solid #dee2e6;">'
      }
      
      // Trouver le nom du niveau de risque pour l'affichage
      const riskLevelName = specificQuestions[0]?.risk_level_name || 'Niveau de risque'
      formHtml += `<div style="color: #96254E; margin: 1rem 0; font-weight: bold;">${riskLevelName}</div>`
      
      specificQuestions.forEach((question, index) => {
        formHtml += this.renderQuestionField(question, index)
      })
    }
    
    formHtml += '<div class="row"><div class="large-12 columns" style="text-align: center;">'
    formHtml += `<button type="submit" class="button medium color-group1">${buttonText}</button>`
    formHtml += '</div></div>'
    formHtml += '</form>'
    
    return formHtml
  }

  // Générer un champ de question
  renderQuestionField(question, index) {
    let fieldHtml = '<div class="question-field" style="margin: 0.75rem 0; padding: 0.75rem; background-color: #f9f9f9; border-radius: 4px; border-left: 3px solid #96254E;">'
    fieldHtml += `<div style="font-weight: bold; margin-bottom: 0.5rem; color: #333;">${question.intitule}`
    if (question.obligatoire) {
      fieldHtml += ' <span style="color: red;">*</span>'
    }
    fieldHtml += '</div>'

    const existingValue = question.existing_answer || ''
    fieldHtml += this.renderInputField(question, existingValue)

    fieldHtml += '</div>'
    return fieldHtml
  }

  // Générer le champ de saisie selon le format
  renderInputField(question, value) {
    switch (question.format) {
      case 'boolean':
        return this.renderBooleanField(question, value)
      case 'textarea':
        return this.renderTextareaField(question, value)
      case 'dropdown':
        return this.renderDropdownField(question, value)
      case 'date':
        return this.renderDateField(question, value)
      case 'number':
        return this.renderNumberField(question, value)
      case 'email':
        return this.renderEmailField(question, value)
      case 'url':
        return this.renderUrlField(question, value)
      case 'phone':
        return this.renderPhoneField(question, value)
      default: // string
        return this.renderTextField(question, value)
    }
  }

  renderBooleanField(question, value) {
    const isChecked = value === 'true' ? 'checked' : ''
    return `
      <input type="hidden" name="answers[${question.id}]" value="false">
      <div style="text-align: left;">
        <input type="checkbox" id="question_${question.id}" name="answers[${question.id}]" value="true" ${isChecked}>
        <label for="question_${question.id}" style="display: inline; margin-left: 5px;">Oui</label>
      </div>
    `
  }

  renderTextareaField(question, value) {
    return `<textarea id="question_${question.id}" name="answers[${question.id}]" class="form-control" rows="4" style="text-align: left; width: 100%;">${value}</textarea>`
  }

  renderDropdownField(question, value) {
    let html = `<select id="question_${question.id}" name="answers[${question.id}]" class="form-control" style="text-align: left; width: 100%;">`
    html += '<option value="">Sélectionnez une option</option>'
    
    if (question.select_options && Array.isArray(question.select_options)) {
      question.select_options.forEach(option => {
        const selected = value === option ? 'selected' : ''
        html += `<option value="${option}" ${selected}>${option}</option>`
      })
    }
    
    html += '</select>'
    return html
  }

  renderDateField(question, value) {
    return `<input type="date" id="question_${question.id}" name="answers[${question.id}]" class="form-control" value="${value}" style="text-align: left;">`
  }

  renderNumberField(question, value) {
    return `<input type="number" id="question_${question.id}" name="answers[${question.id}]" class="form-control" value="${value}" style="text-align: left;" step="any">`
  }

  renderEmailField(question, value) {
    return `<input type="email" id="question_${question.id}" name="answers[${question.id}]" class="form-control" value="${value}" style="text-align: left;">`
  }

  renderUrlField(question, value) {
    return `<input type="url" id="question_${question.id}" name="answers[${question.id}]" class="form-control" value="${value}" style="text-align: left;" placeholder="https://">`
  }

  renderPhoneField(question, value) {
    return `<input type="tel" id="question_${question.id}" name="answers[${question.id}]" class="form-control" value="${value}" style="text-align: left;">`
  }

  renderTextField(question, value) {
    return `<input type="text" id="question_${question.id}" name="answers[${question.id}]" class="form-control" value="${value}" style="text-align: left;">`
  }

  // Générer l'affichage des réponses existantes
  renderExistingAnswers(answersByRiskLevel, firstRiskLevel, currentRiskLevelId) {
    console.log('🔍 renderExistingAnswers appelé avec:', { answersByRiskLevel, firstRiskLevel, currentRiskLevelId })
    
    // Récupérer le groupe des questions générales (sans niveau de risque)
    const generalQuestionsData = answersByRiskLevel.find(riskLevelData => riskLevelData.risk_level.id == null)
    console.log('🔍 Questions générales trouvées:', generalQuestionsData)
    
    // Récupérer le groupe du niveau de risque sélectionné (si spécifié)
    let currentRiskLevelData = null
    let riskLevelToDisplay = null
    
    if (currentRiskLevelId !== null && currentRiskLevelId !== undefined && currentRiskLevelId !== '') {
      const wantedId = String(currentRiskLevelId)
      currentRiskLevelData = answersByRiskLevel.find(riskLevelData => {
        if (!riskLevelData || !riskLevelData.risk_level || riskLevelData.risk_level.id === null || riskLevelData.risk_level.id === undefined) {
          return false
        }
        return String(riskLevelData.risk_level.id) === wantedId
      })
      console.log('🔍 Niveau de risque sélectionné trouvé:', currentRiskLevelData)
      
      if (currentRiskLevelData) {
        riskLevelToDisplay = currentRiskLevelData.risk_level
      }
    } else {
      // Si aucun niveau spécifique, utiliser le premier disponible
      riskLevelToDisplay = firstRiskLevel
      if (riskLevelToDisplay) {
        currentRiskLevelData = answersByRiskLevel.find(riskLevelData => 
          riskLevelData.risk_level && riskLevelData.risk_level.id === riskLevelToDisplay.id
        )
      }
    }

    // Si aucune donnée trouvée, rien à afficher
    if (!currentRiskLevelData && !generalQuestionsData) {
      console.log('⚠️ Aucune donnée trouvée pour l\'affichage')
      return ''
    }

    let html = ''

    // D'abord, afficher les questions générales (si présentes)
    if (generalQuestionsData && Array.isArray(generalQuestionsData.questions) && generalQuestionsData.questions.length > 0) {
      console.log(`✅ Affichage de ${generalQuestionsData.questions.length} questions générales`)
      html += `<div style="color: #96254E; margin: 0.5rem 0;">Questions générales</div>`
      generalQuestionsData.questions.forEach(question => {
        html += this.renderAnswerItem(question)
      })
    }

    // Puis, ajouter les réponses du niveau sélectionné (si présentes)
    if (currentRiskLevelData && currentRiskLevelData.questions) {
      console.log(`✅ Affichage de ${currentRiskLevelData.questions.length} questions du niveau ${riskLevelToDisplay?.nom}`)
      // Ajout d'un petit séparateur visuel si on a déjà des questions générales
      if (html) {
        html += `<div style="margin: 1rem 0; border-top: 1px solid #ddd;"></div>`
      }
      html += `<div style="color: #96254E; margin: 0.5rem 0;">${riskLevelToDisplay?.nom || 'Niveau de risque'}</div>`
      currentRiskLevelData.questions.forEach(question => {
        html += this.renderAnswerItem(question)
      })
    }

    const result = {
      riskLevelName: riskLevelToDisplay ? riskLevelToDisplay.nom : (generalQuestionsData ? 'Questions générales' : ''),
      html: html
    }
    
    console.log('🔍 Résultat du rendu:', result)
    return result
  }

  renderAnswerItem(question) {
    const answerText = this.formatAnswer(question)
    
    let html = `<div class="question-answer" style="margin: 0.75rem 0; padding: 0.75rem; background-color: #f9f9f9; border-radius: 4px; border-left: 3px solid #96254E;">`
    html += `<div style="font-weight: bold; margin-bottom: 0.5rem; color: #333;">${question.intitule}</div>`
    
    if (question.format === 'textarea') {
      html += `<div style="color: #666; font-style: italic;">Réponse :</div>`
      html += `<div style="background-color: white; padding: 0.5rem; border-radius: 3px; border: 1px solid #ddd; margin-top: 0.25rem; white-space: pre-wrap;">${answerText}</div>`
    } else {
      html += `<div style="color: #666; font-style: italic;">Réponse : <strong>${answerText}</strong></div>`
    }
    
    html += `</div>`
    return html
  }

  formatAnswer(question) {
    if (!question.answer) {
      return 'Aucune réponse'
    }

    switch (question.format) {
      case 'boolean':
        return question.answer === 'true' ? 'Oui' : 'Non'
      case 'textarea':
        return question.answer.replace(/\n/g, '<br>')
      case 'date':
        const date = new Date(question.answer)
        return !isNaN(date.getTime()) ? date.toLocaleDateString('fr-FR') : question.answer
      case 'number':
        const num = parseFloat(question.answer)
        return !isNaN(num) ? num.toLocaleString('fr-FR') : question.answer
      case 'email':
        return `<a href="mailto:${question.answer}">${question.answer}</a>`
      case 'url':
        let url = question.answer
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = 'https://' + url
        }
        return `<a href="${url}" target="_blank">${question.answer}</a>`
      case 'phone':
        return `<a href="tel:${question.answer}">${question.answer}</a>`
      default:
        return question.answer
    }
  }

  getRiskLevelToDisplay(answersByRiskLevel, firstRiskLevel, currentRiskLevelId) {
    if (currentRiskLevelId) {
      const selectedRiskLevel = answersByRiskLevel.find(riskLevelData => 
        riskLevelData.risk_level.id.toString() === currentRiskLevelId.toString()
      )
      if (selectedRiskLevel) {
        return selectedRiskLevel.risk_level
      }
    }
    return firstRiskLevel
  }

  // Générer l'indicateur de chargement
  renderLoading() {
    return `<div class="loading-indicator">Chargement...</div>`
  }
} 